const DeviceReplacement = {
  DeviceReplacement: {
    toDoText:
      'Bitte stellen Sie sicher, dass die folgenden Schritte durchgeführt wurden, bevor Sie den Austausch einleiten',
    toDoListItems: [
      'Trennen Sie das zu ersetzende Gerät vom Netz',
      'Anschließen des Ersatzgeräts',
      'Konfigurieren Sie das Ersatzgerät'
    ],
    install_replacement: {
      submitFirstStep: 'Details abrufen',
      labelOldDevice: 'Details des alten Geräts',
      labelNewDevice: 'Details des neuen Geräts',
      submitSecondStep: 'Bestätigen Sie den Austausch',
      hems_device_api_fault:
        'Wenn Sie versuchen, eine aktive Last eines Drittanbieters zu ersetzen, diese aber nicht in der Auswahlliste angezeigt wird, laden Sie bitte die Seite neu.',
      warningText: `Falls die Gerätedaten nicht korrekt sind oder ein anderes Problem vorliegt, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >klicken Sie hier</a>, um zurückzugehen`,
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        EVSE: 'IQ ER EVSE',
        IQ_GATEWAY: 'IQ Gateway',
        ENERGY_METER: 'Energiemessgerät',
        SG_READY_GATEWAY: 'SG Bereitschaftsrelais',
        MICROINVERTER: 'Mikro-Wechselrichter',
        AC_BATTERY: 'AC-Batterie',
        selectDeviceType: 'Gerätetyp auswählen'
      }
    },
    replace_gateway: {
      submitFirstStep: 'IQ Energy Router austauschen',
      submitSecondStep: 'IQ Energy Router austauschen',
      hems_device_api_fault:
        'Wenn Sie versuchen, einen aktiven IQ Energy Router zu ersetzen, dieser aber nicht in der Auswahlliste angezeigt wird, laden Sie die Seite bitte neu.',
      warningText: `Falls die Gerätedaten nicht korrekt sind oder ein anderes Problem vorliegt, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >klicken Sie hier</a>, um zurückzugehen`,
      labelOldDevice: 'Alte IQ ER-Details',
      labelNewDevice: 'Neue IQ ER-Details',
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectGatewayType: 'Gateway-Typ auswählen '
      }
    },
    alert: {
      footerMessage: 'Falls das Problem weiterhin besteht, wenden Sie sich bitte an den Enphase-Kundendienst.',
      requestTimedOut: {
        mainMessage: 'Zeitüberschreitung der Anfrage',
        subMessage: 'Bitte versuchen Sie es später noch einmal'
      },
      multipleDeviceFound: {
        mainMessage: 'Austausch nicht unterstützt',
        subMessageIqErEvse:
          'Es wurden mehr als 1 IQ ER EVSE am Standort erkannt. Der Austausch kann für diese Art von Standortkonfiguration nicht unterstützt werden.',
        subMessageEnergyMeter:
          'Am Standort werden mehr als 1 Energiezähler erkannt. Der Austausch kann für diese Art von Standortkonfiguration nicht unterstützt werden.',
        subMessageSgReadyRelay:
          'Am Standort werden mehr als 1 SG Ready Relays erkannt. Der Austausch kann für diese Art der Standortkonfiguration nicht unterstützt werden.'
      },
      iqErOffline: {
        mainMessage: 'IQ ER meldet sich nicht',
        subMessage:
          'Bitte stellen Sie sicher, dass der IQ Energy Router mit Strom versorgt wird und mit dem Internet verbunden ist'
      },
      deviceNotOffline: {
        mainMessage: 'Altes Gerät angeschlossen',
        subMessage:
          'Verbindung mit altem Gerät erkannt. Bitte trennen Sie das alte Gerät und starten Sie den Austausch erneut.'
      },
      deviceReplacementInProgress: {
        mainMessage: 'Geräteaustausch für diesen Gerätetyp ist bereits im Gange'
      },
      deviceNotFound: {
        mainMessage: 'Neues Gerät nicht erkannt',
        subMessage:
          'Details des neuen Geräts nicht gefunden. Bitte stellen Sie sicher, dass das neue Gerät mit dem Internet verbunden und konfiguriert ist.'
      },
      invalidRmaStatusId: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Ersetzung fehlgeschlagen wegen unbekanntem Ersetzungsstatus'
      },
      activationDuplicateSite: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Austausch fehlgeschlagen, da der neue IQ Energy Router bereits aktiv ist'
      },
      authPending: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Vervanging mislukt omdat de bestaande IQ Energy Router nog niet is geautoriseerd'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Vervanging mislukt omdat het ingevoerde serienummer van de IQ Energy Router ongeldig is'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Vervanging mislukt omdat de eerder ontdekte HEMS 3rd party apparaten niet worden gevonden'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Vervanging mislukt omdat de IQ Gateway nog niet is ontdekt door de IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Austausch fehlgeschlagen',
        subMessage: 'Vervanging mislukt omdat autorisatie van het apparaat niet is gestart'
      },
      invalidDeviceType: {
        mainMessage: 'Gerätetyp für Austausch nicht gültig',
        subMessage:
          'Bitte vergewissern Sie sich, dass der richtige Gerätetyp ausgewählt wurde, bevor Sie die Anfrage abschicken'
      },
      invalidSite: {
        mainMessage: 'Nicht unterstützter Standorttyp',
        subMessage: 'Die Standortkonfiguration unterstützt diese Ersetzung nicht'
      },
      invalidDevice: {
        mainMessage: 'Alte Geräte-ID sieht ungültig aus',
        subMessage: 'Die Ersetzung wird für dieses Gerät nicht unterstützt'
      },
      invalidDeviceUid: {
        mainMessage: 'Alte und neue Geräte-IDs sind identisch',
        subMessage: 'Die Ersetzung wird für dieses Gerät nicht unterstützt'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Austausch abgeschlossen',
        subMessage:
          'Wenn die Funktionsvalidierung für das neue Gerät noch aussteht, schließen Sie sie bitte mit der Enphase Installer Application (ITK) ab.'
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger wurde erfolgreich ausgetauscht',
        energyMeter: 'Energiezähler wurde erfolgreich ausgetauscht',
        sgReadyRelay: 'SG Ready Relay wurde erfolgreich ausgetauscht',
        iqEnergyRouter: 'IQ Energy Router wurde erfolgreich ersetzt'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Gerätedetails abrufen' },
      initiatingReplacementLoader: { subMessage: 'Austausch einleiten' },
      replacementInprogressLoader: { subMessage: 'Austausch wird durchgeführt' }
    }
  }
};

export default DeviceReplacement;
